import { createHash } from 'crypto';

//This is needed to calculate the id of the keys in Runtime due to conflict with react-intl and Next.js.
export function computeMessageId(message: string, description = ''): string {
  const input = description ? `${message}#${description}` : message;
  const hash = createHash('sha512').update(input).digest('base64');
  return hash.slice(0, 6);
}
